/**
 * Device Detection
 *
 * Sets an CSS class to the body for Device optimizing
 *
 * @module DeviceDetection
 */
(function DeviceDetection() {

    var DeviceDetect = {
        init: function () {
            var b = document.documentElement;
            // handle visibility of navigation
            if (Modernizr.touchevents) {
                // if touch device load only responsive nav
                b.setAttribute('data-device', 'touch');
            } else {
                // if desktop pc load breakpoint based nav
                if (window.innerWidth >= 992) {
                    b.setAttribute('data-device', 'desktop');
                } else {
                    b.setAttribute('data-device', 'touch');
                }

                // observe resize window to change breakpoint based nav
                $(document).ready(function () {
                    $(window).resize(function () {
                        if (window.innerWidth >= 992) {
                            b.setAttribute('data-device', 'desktop');
                        } else {
                            b.setAttribute('data-device', 'touch');
                        }
                    });
                });

                // fallback for unknown touch devices:
                // https://codeburst.io/the-only-way-to-detect-touch-with-javascript-7791a3346685
                window.addEventListener('touchstart', function onFirstTouch() {
                    // we could use a class
                    b.setAttribute('data-device', 'touch');

                    // we only need to know once that a human touched the screen, so we can stop listening now
                    window.removeEventListener('touchstart', onFirstTouch, false);
                }, false);
            }
        }
    };


    $(document).ready(function () {
        DeviceDetect.init();
    });

})();